import getAncestors from "./getAncestors";
export default (function (parent, target) { return getAncestors(target).some(function (node) { return node === parent; }); });
